import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { sdk } from "./sdk"

export type GiftCard = {
  id: string
  last4: string
  initial_value: number
  balance: number
  currency_code: string
  status: "active" | "disabled" | "expired" | "depleted"
  expires_at: string | null
  recipient_email: string | null
  customer_id: string | null
  note: string
  created_by: string
  created_at: string
}
export type GiftCardTx = { id: string; kind: string; amount: number; balance_after: number; order_id: string | null; actor: string; note: string; created_at: string }

export function useGiftCards(p: { q?: string; status?: string; limit: number; offset: number }) {
  return useQuery({
    queryKey: ["gift-cards", "list", p],
    placeholderData: keepPreviousData,
    queryFn: () => sdk.client.fetch<{ gift_cards: GiftCard[]; count: number; outstanding: number }>("/admin/terify/gift-cards", { query: { q: p.q?.trim() || undefined, status: p.status || undefined, limit: p.limit, offset: p.offset } }),
  })
}
export function useGiftCard(id: string) {
  return useQuery({ queryKey: ["gift-cards", id], queryFn: () => sdk.client.fetch<{ gift_card: GiftCard; transactions: GiftCardTx[] }>(`/admin/terify/gift-cards/${id}`) })
}
export function useIssueGiftCard() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: { amount: number; code?: string; expires_at?: string | null; recipient_email?: string | null; note?: string }) => sdk.client.fetch<{ card: GiftCard; code: string }>("/admin/terify/gift-cards", { method: "POST", body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["gift-cards"] }),
  })
}
export function useUpdateGiftCard(id: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: { enabled?: boolean; expires_at?: string | null; note?: string; adjust?: number; adjust_note?: string }) => sdk.client.fetch<{ gift_card: GiftCard; transactions: GiftCardTx[] }>(`/admin/terify/gift-cards/${id}`, { method: "POST", body }),
    onSuccess: (r) => {
      qc.setQueryData(["gift-cards", id], r)
      qc.invalidateQueries({ queryKey: ["gift-cards", "list"] })
    },
  })
}
